export const EMAIL_VERIFICATION_STATUSES = ['success', 'error', 'already-verified'] as const;

export type EmailVerificationStatus = (typeof EMAIL_VERIFICATION_STATUSES)[number];
